import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Spinner } from '../components/Spinner';

export function AuthLayout() {
  const { firebaseUser, loading } = useAuthStore();
  if (loading) return <Spinner full />;
  // Already-authenticated & verified users skip the auth screens.
  if (firebaseUser?.emailVerified) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-felt-dark to-black px-4">
      <div className="w-full max-w-md">
        <h1 className="mb-6 text-center text-3xl font-bold text-gold">
          ♠ Royal Tokens Casino
        </h1>
        <div className="card">
          <Outlet />
        </div>
        <p className="mt-4 text-center text-xs text-slate-500">
          Tokens are for gameplay only — no cash value.
        </p>
      </div>
    </div>
  );
}
